import React from 'react';
import { Box, Typography } from '@mui/material';
import { useMember } from '../contexts/MemberContext';
import { formatPoints } from '../utils/formatters';

/**
 * Welcome Section Component
 * Displays welcome message with member name and current points
 */
const WelcomeSection = () => {
  const { member } = useMember();

  return (
    <Box>
      <Typography variant="h4" component="h1" align="center" gutterBottom>
        Welcome, {member?.first_name || 'Guest'}!
      </Typography>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection={'row'}
        sx={{
          mt: 1,
          py: 1,
          px: 3,
          gap: 1
        }}
      >
        <Typography variant="h6" align="center">
          You currently have{' '}
        </Typography>
        <Box
          component="span"
          sx={{
            fontWeight: 'bold',
            color: '#B59410',
            textShadow: '0px 0px 1px rgba(0,0,0,0.3)'
          }}
        >
          {formatPoints(member?.current_points)}
        </Box>
        <Typography variant="h6" align="center">
          points
        </Typography>
      </Box>
    </Box>
  );
};

export default WelcomeSection;